import {
  Briefcase,
  Calculator,
  Code2,
  Compass,
  Megaphone,
  UserRound,
} from "lucide-react";

import { Section, SectionHeading } from "@/components/ui/Section";
import { useLocale } from "@/i18n";

export function Workforce() {
  const { t } = useLocale();
  const d = t.workforce.departments;

  const departments = [
    { icon: Compass, ...d.strategy },
    { icon: Megaphone, ...d.marketing },
    { icon: Calculator, ...d.finance },
    { icon: Briefcase, ...d.operations },
    { icon: Code2, ...d.engineering },
    { icon: UserRound, ...d.people },
  ];

  return (
    <Section id="workforce">
      <SectionHeading title={t.workforce.title} subtitle={t.workforce.subtitle} />

      <ul className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {departments.map(({ icon: Icon, name, role }) => (
          <li
            key={name}
            className="group card-surface flex items-start gap-4 p-6 transition-colors duration-500 hover:border-emerald-400/20"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/[0.04] ring-1 ring-white/8 transition-colors duration-500 group-hover:bg-emerald-500/10 group-hover:ring-emerald-400/20">
              <Icon
                size={18}
                aria-hidden
                className="text-cream-100/60 transition-colors duration-500 group-hover:text-emerald-300"
              />
            </span>
            <div className="min-w-0">
              <h3 className="font-semibold text-cream-50">{name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-cream-100/52">
                {role}
              </p>
            </div>
          </li>
        ))}
      </ul>

      <p className="mt-10 text-center text-sm text-cream-100/45">
        {t.workforce.note}
      </p>
    </Section>
  );
}
